(function () {
  const jsonLesen = (el) => {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('Produkt-Pairing: JSON konnte nicht gelesen werden.', e);
      return null;
    }
  };

  const entitaetenLoesen = (text) => {
    const feld = document.createElement('textarea');
    feld.innerHTML = text;
    return feld.value;
  };

  const geldFormatieren = (cent, format) => {
    const muster = /\{\{\s*(\w+)\s*\}\}/;
    const sauber = entitaetenLoesen(String(format || '').replace(/<[^>]*>/g, ''));
    const treffer = sauber.match(muster);
    if (!treffer) return sauber;

    const bauen = (nachkommastellen, tausender, dezimal) => {
      if (isNaN(cent) || cent === null) return '0';
      const teile = (cent / 100.0).toFixed(nachkommastellen).split('.');
      const ganz = teile[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + tausender);
      return teile[1] ? ganz + dezimal + teile[1] : ganz;
    };

    let wert;
    switch (treffer[1]) {
      case 'amount_no_decimals':
        wert = bauen(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        wert = bauen(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        wert = bauen(0, '.', ',');
        break;
      case 'amount_with_space_separator':
        wert = bauen(2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        wert = bauen(0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        wert = bauen(2, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        wert = bauen(2, "'", '.');
        break;
      default:
        wert = bauen(2, ',', '.');
    }
    return sauber.replace(muster, wert);
  };

  class PairingZeile {
    constructor(zeile, panel) {
      this.zeile = zeile;
      this.panel = panel;
      this.variante = jsonLesen(zeile.querySelector('[data-pp-slide-data]'));
      if (!this.variante || !this.variante.id) return;

      this.haken = zeile.querySelector('[data-pp-pick]');
      if (this.haken) this.haken.addEventListener('change', () => this.melden());

      this.melden();
    }

    get gewaehlt() {
      if (!this.variante || !this.variante.available) return null;
      if (!this.haken || !this.haken.checked) return null;
      return this.variante;
    }

    melden() {
      this.zeile.classList.toggle('is-gewaehlt', Boolean(this.gewaehlt));
      if (this.panel) this.panel.neuRechnen();
    }
  }

  class PairingPanel {
    constructor(panel, wurzel) {
      this.panel = panel;
      this.wurzel = wurzel;
      this.texte = wurzel.texte;

      this.knopf = panel.querySelector('[data-pp-submit]');
      this.knopfText = panel.querySelector('[data-pp-submit-label]');
      this.fehler = panel.querySelector('[data-pp-error]');
      this.spinner = panel.querySelector('.loading__spinner');

      this.zeilen = [];
      panel.querySelectorAll('[data-pp-slide]').forEach((zeile) => {
        this.zeilen.push(new PairingZeile(zeile, this));
      });

      if (this.knopf) this.knopf.addEventListener('click', () => this.inDenWarenkorb());

      this.aufAnfang = () => {};

      this.karussellAufbauen();
      this.neuRechnen();
    }

    karussellAufbauen() {
      const bahn = this.panel.querySelector('[data-pp-slides]');
      const punkte = Array.from(this.panel.querySelectorAll('[data-pp-dot]'));
      if (!bahn || !bahn.classList.contains('pp__slides--karussell') || punkte.length < 2) return;

      const zeilen = this.zeilen.map((eintrag) => eintrag.zeile);
      let eigenerLauf = false;
      let uhr = null;

      const setzen = (aktiv) => {
        punkte.forEach((punkt, index) => punkt.setAttribute('aria-current', String(index === aktiv)));
      };

      const markieren = () => {
        const mitte = bahn.scrollLeft + bahn.clientWidth / 2;
        let aktiv = 0;
        zeilen.forEach((zeile, index) => {
          if (mitte >= zeile.offsetLeft) aktiv = index;
        });
        setzen(aktiv);
      };

      punkte.forEach((punkt, index) => {
        punkt.addEventListener('click', () => {
          const ziel = zeilen[index];
          if (!ziel) return;
          eigenerLauf = true;
          setzen(index);
          window.clearTimeout(uhr);
          uhr = window.setTimeout(() => {
            eigenerLauf = false;
          }, 600);
          bahn.scrollTo({ left: ziel.offsetLeft, behavior: 'smooth' });
        });
      });

      bahn.addEventListener(
        'scroll',
        () => {
          if (eigenerLauf) return;
          markieren();
        },
        { passive: true }
      );

      this.aufAnfang = () => {
        window.clearTimeout(uhr);
        eigenerLauf = false;
        bahn.scrollLeft = 0;
        setzen(0);
      };

      markieren();
    }

    get gewaehlte() {
      return this.zeilen.map((zeile) => zeile.gewaehlt).filter(Boolean);
    }

    neuRechnen() {
      const gewaehlte = this.gewaehlte;
      const cent = gewaehlte.reduce((summe, variante) => summe + variante.price, 0);
      const summeText = geldFormatieren(cent, this.texte.moneyFormat);

      if (!this.knopf || !this.knopfText) return;

      if (!gewaehlte.length) {
        this.knopf.disabled = true;
        this.knopf.setAttribute('aria-disabled', 'true');
        this.knopfText.textContent = this.texte.leer || '';
        return;
      }

      this.knopf.disabled = false;
      this.knopf.setAttribute('aria-disabled', 'false');

      const kauftext = this.texte.kaufen || 'In den Warenkorb';
      this.knopfText.textContent = [kauftext, summeText].filter(Boolean).join(' • ');
    }

    fehlerZeigen(text) {
      if (!this.fehler) return;
      this.fehler.textContent = text || '';
      this.fehler.hidden = !text;
    }

    warenkorbFinden() {
      const gefunden = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!gefunden) return null;
      if (typeof gefunden.getSectionsToRender !== 'function') return null;
      if (typeof gefunden.renderContents !== 'function') return null;
      return gefunden;
    }

    async inDenWarenkorb() {
      const gewaehlte = this.gewaehlte;
      if (!gewaehlte.length || this.laeuft || !this.knopf) return;

      this.laeuft = true;
      this.fehlerZeigen('');
      this.knopf.classList.add('loading');
      this.knopf.setAttribute('aria-disabled', 'true');
      if (this.spinner) this.spinner.classList.remove('hidden');

      try {
        const adressen = window.routes || {};
        if (!adressen.cart_add_url) throw new Error('routes.cart_add_url fehlt');

        const warenkorb = this.warenkorbFinden();
        const inhalt = { items: gewaehlte.map((variante) => ({ id: variante.id, quantity: 1 })) };

        if (warenkorb) {
          inhalt.sections = warenkorb.getSectionsToRender().map((abschnitt) => abschnitt.id);
          inhalt.sections_url = window.location.pathname;
          if (typeof warenkorb.setActiveElement === 'function') {
            warenkorb.setActiveElement(document.activeElement);
          }
        }

        const antwort = await fetch(adressen.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(inhalt),
        });
        const ergebnis = await antwort.json();

        if (ergebnis.status) {
          this.fehlerZeigen(ergebnis.description || ergebnis.message || this.texte.fehler);
          return;
        }

        if (!warenkorb) {
          window.location = adressen.cart_url || '/cart';
          return;
        }

        const ersterArtikel = (ergebnis.items && ergebnis.items[0]) || {};
        warenkorb.renderContents(
          Object.assign({}, ergebnis, { key: ersterArtikel.key, id: ersterArtikel.product_id })
        );

        if (warenkorb.classList.contains('is-empty')) warenkorb.classList.remove('is-empty');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'produktpairing-block', cartData: ergebnis });
        }
      } catch (e) {
        console.error('Produkt-Pairing: Hinzufügen fehlgeschlagen.', e);
        this.fehlerZeigen(this.texte.fehler);
      } finally {
        this.laeuft = false;
        this.knopf.classList.remove('loading');
        if (this.spinner) this.spinner.classList.add('hidden');
        this.neuRechnen();
      }
    }
  }

  class Pairing {
    constructor(wurzel) {
      this.wurzel = wurzel;
      this.texte = jsonLesen(wurzel.querySelector('[data-pp-strings]')) || {};
      this.reiter = Array.from(wurzel.querySelectorAll('[data-pp-tab]'));
      this.panels = Array.from(wurzel.querySelectorAll('[data-pp-panel]'));

      this.reiter.forEach((knopf, index) => {
        knopf.addEventListener('click', () => this.reiterWaehlen(knopf.dataset.ppTab));
        knopf.addEventListener('keydown', (ereignis) => this.reiterTaste(ereignis, index));
      });

      this.panels.forEach((panel) => {
        this.panelStarten(panel);
        if (!panel.hidden) panel.dataset.ppGezeigt = 'true';
      });

      this.empfehlungenLaden();
    }

    panelStarten(panel) {
      panel.pairingPanel = new PairingPanel(panel, this);
    }

    reiterTaste(ereignis, index) {
      const schritte = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      let ziel = null;

      if (ereignis.key === 'Home') {
        ziel = 0;
      } else if (ereignis.key === 'End') {
        ziel = this.reiter.length - 1;
      } else if (schritte[ereignis.key] !== undefined) {
        ziel = (index + schritte[ereignis.key] + this.reiter.length) % this.reiter.length;
      }

      if (ziel === null) return;

      const knopf = this.reiter[ziel];
      if (!knopf) return;

      ereignis.preventDefault();
      this.reiterWaehlen(knopf.dataset.ppTab);
      knopf.focus();
    }

    reiterWaehlen(id) {
      this.reiter.forEach((knopf) => {
        const aktiv = knopf.dataset.ppTab === id;
        knopf.setAttribute('aria-selected', String(aktiv));
        knopf.tabIndex = aktiv ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const sichtbar = panel.dataset.ppPanel === id;
        panel.hidden = !sichtbar;
        if (!sichtbar || panel.dataset.ppGezeigt === 'true') return;

        panel.dataset.ppGezeigt = 'true';
        if (panel.pairingPanel) panel.pairingPanel.aufAnfang();
      });
    }

    empfehlungenLaden() {
      const offen = this.panels.filter(
        (panel) => panel.dataset.ppSource !== 'manuell' && panel.dataset.ppFill !== 'empfehlung'
      );
      if (!offen.length) return;

      const daten = this.wurzel.dataset;
      if (!daten.ppProduct || !daten.ppSection || !daten.ppUrl) return;

      offen.forEach((panel) => this.panelFuellen(panel));
    }

    async panelFuellen(panel) {
      const kette = panel.dataset.ppIntent === 'related' ? ['related'] : ['complementary', 'related'];

      for (const art of kette) {
        const dokument = await this.dokument(art);
        if (!dokument) continue;

        const neu = dokument.querySelector(`[data-pp-panel="${panel.dataset.ppPanel}"]`);
        if (!neu || neu.dataset.ppFill !== 'empfehlung' || !neu.innerHTML.trim()) continue;

        panel.innerHTML = neu.innerHTML;
        panel.dataset.ppFill = 'empfehlung';
        this.panelStarten(panel);
        return;
      }
    }

    dokument(art) {
      if (!this.dokumente) this.dokumente = {};
      if (this.dokumente[art]) return this.dokumente[art];

      const daten = this.wurzel.dataset;
      const adresse =
        `${daten.ppUrl}?section_id=${encodeURIComponent(daten.ppSection)}` +
        `&product_id=${encodeURIComponent(daten.ppProduct)}` +
        `&limit=${encodeURIComponent(daten.ppLimit || 2)}&intent=${art}`;

      this.dokumente[art] = fetch(adresse)
        .then((antwort) => (antwort.ok ? antwort.text() : Promise.reject(new Error(String(antwort.status)))))
        .then((text) => new DOMParser().parseFromString(text, 'text/html'))
        .catch((e) => {
          console.error('Produkt-Pairing: Empfehlungen konnten nicht geladen werden.', e);
          return null;
        });

      return this.dokumente[art];
    }
  }

  const starten = (bereich) => {
    const ziel = bereich || document;
    const wurzeln = [];

    if (typeof ziel.matches === 'function' && ziel.matches('[data-pp-root]')) {
      wurzeln.push(ziel);
    }
    if (typeof ziel.querySelectorAll === 'function') {
      wurzeln.push(...ziel.querySelectorAll('[data-pp-root]'));
    }

    wurzeln.forEach((wurzel) => {
      if (wurzel.dataset.ppReady === 'true') return;
      wurzel.dataset.ppReady = 'true';
      wurzel.pairing = new Pairing(wurzel);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => starten());
  } else {
    starten();
  }

  document.addEventListener('shopify:section:load', (event) => starten(event.target));

  document.addEventListener('shopify:block:select', (event) => starten(event.target));
})();
